import ReactDOM from 'react-dom';
import { getTreeSync } from 'src/utils/freedom-resolve';
import loadable from 'src/common/loadable';
import * as I18n from 'src/utils/i18n';
import Breadcrumb from './components/breadcrumb';
import Title from './components/title';
import MainImage from './components/pc-main-image';
import MarketAction from './components/detail-market-action';
import TitleAccessory from './components/title-accessory';
import CompanyCard from './components/company-card';
import Coupon from './components/coupon';
import Price from './components/price';
import GLP from './components/glp';
import Tabs from './components/tabs';
import FeedBack from './components/feedback';
import CompanyHightlightSlot from './components/company-highlight-slot';
import Actions from './components/actions';
import initDetailRenderAdapter from './utils/detail-render-adapter';
import initGlobalSerivce from './service/global-service';
import SeoRelatedSearch from './components/seo-related-search';
import Benefits from './components/pc-benefits';
import SimilarCategory from './components/seo-similar-category';
import EpidemicBanner from './components/epidemic-banner';
import SeoRfq from './components/seo-rfq';
import SkuAttrs from './components/sku-attrs';
import CompanyFooter from './components/company-footer';
import RiskWarning from './components/risk-warning';
import initCommonData from './components/common-data';
import DetailCertification from './components/certification';

// import hierarchy from './mock/hierarchy';
// import nodeMap from './mock/node-map';

import './index.scss';

window.ReactDom = ReactDOM;

function Layout(props) {
  if (!props) return;

  // to delete
  // props.hierarchy = hierarchy;
  // props.nodeMap = nodeMap;

  I18n.setRoot(props.globalData.i18n);

  const PdpPlatform = getTreeSync(props, {
    Breadcrumb,
    Title,
    MainImage,
    RiskWarning,
    MarketAction,
    TitleAccessory,
    DetailCertification,
    CompanyCard,
    Price,
    GLP,
    EpidemicBanner,
    SkuAttrs,
    Tabs,
    RecommendProducts: loadable(() =>
      import(
        /* webpackChunkName: "recommend-products" */ './components/recommend-products'
      ),
    ),
    FeedBack,
    Alisite: loadable(() =>
      import(/* webpackChunkName: "alisite" */ './components/alisite'),
    ),
    Actions,
    Coupon,
    Benefits,
    CompanyFooter,
    SeoRelatedSearch,
    CompanyHightlightSlot,
    SimilarCategory,
    SeoRfq,
    DetailDiscuss: loadable(() =>
      import(
        /* webpackChunkName: "detail-discuss" */ './components/detail-discuss'
      ),
    ),
    DetailVideo: loadable(() =>
      import(
        /* webpackChunkName: "detail-video" */ './components/detail-video'
      ),
    ),
    SiderBar: loadable(
      () => import(/* webpackChunkName: "sidebar" */ './components/sidebar'),
      {
        loadingVisible: false,
      },
    ),
    ProductPackagingAndQuickDetail: loadable(() =>
      import(
        /* webpackChunkName: "product-packaging-and-quick-detail" */ './components/product-packaging-and-quick-detail'
      ),
    ),
    TransactionHistory: loadable(
      () =>
        import(
          /* webpackChunkName: "transaction-history" */ './components/transaction-history'
        ),
      {
        loadingVisible: true,
      },
    ),
    ProductSpecification: loadable(() =>
      import(
        /* webpackChunkName: "product-specification" */ './components/product-specification'
      ),
    ),
    ProductAuth: loadable(() =>
      import(
        /* webpackChunkName: "product-auth" */ './components/product-auth'
      ),
    ),
    ShoppingAds: loadable(() =>
      import(
        /* webpackChunkName: "shopping-ads" */ './components/shopping-ads'
      ),
    ),
    SceneRelatedProducts: loadable(() =>
      import(
        /* webpackChunkName: "scene-related-products" */ './components/scene-related-products'
      ),
    ),
  });
  return PdpPlatform;
}

// ssr逻辑
if (window.__getComponentInNode) {
  // ssr 获取组件
  window.__getComponentInNode(Layout);
} else {
  initDetailRenderAdapter();
  const { globalData } = window.detailData;
  initGlobalSerivce(globalData);
  initCommonData(globalData);
  const App = Layout(window.detailData);
  ReactDOM.render(App, document.querySelector('#container'));
}
